import React from 'react';
import { MenuActions } from '../types';
import ActionsMenu from '../../../../ActionsMenu';
import { SingleSelectOption } from '../../../../Dropdown/SingleSelect';

interface IProps {
  /**
   * Since the action behavior is different for each bucket type,
   *  we need to pass the callback function to the action.
   * @param action all actions from enumBucket and RangeBucket
   * @param rowIndex bucket index
   */
  onClick: (action: MenuActions, rowIndex: number) => void;
  rowIndex: number;
  showAddBin?: boolean;
  showRemoveBin?: boolean;
  showRenameBin?: boolean;
}

export default ({
  showAddBin = false,
  showRemoveBin = false,
  showRenameBin = false,
  onClick,
  rowIndex,
}: IProps) => {
  return (
    <ActionsMenu strategy="fixed">
      {showAddBin && (
        <SingleSelectOption
          iconName="plus"
          label={'Add Bin'}
          onClick={() => onClick(MenuActions.Add, rowIndex)}
        />
      )}
      {showRemoveBin && (
        <SingleSelectOption
          iconName="trash"
          label={'Remove Bin'}
          onClick={() => onClick(MenuActions.Remove, rowIndex)}
        />
      )}
      {showRenameBin && (
        <SingleSelectOption
          iconName="pencil"
          label={'Edit Name'}
          onClick={() => onClick(MenuActions.Edit, rowIndex)}
        />
      )}
    </ActionsMenu>
  );
};
